import { FC, memo } from 'react';
import styled from 'styled-components';

import { PremierText, DefaultTitle } from '@components/text';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
`;

const Title = styled(PremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize['5xl']};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.white};
  margin-top: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fonts.fontSize['4xl']};
  }
`;

const Subtitle = styled(DefaultTitle)`
  font-size: ${({ theme }) => theme.fonts.fontSize.base};
  color: ${({ theme }) => theme.colors.grey[200]};
  max-width: 400px;
  line-height: 1.5;
`;

type AuthTitleProps = {
  title: string;
  subtitle?: string;
};

const AuthTitle: FC<AuthTitleProps> = ({ title, subtitle }) => {
  return (
    <TitleContainer>
      <Title>{title}</Title>

      {subtitle ? <Subtitle>{subtitle}</Subtitle> : null}
    </TitleContainer>
  );
};

export default memo(AuthTitle);
